import { useQuery, UseQueryOptions } from 'react-query';
import { StatusesService } from '../../services';
import { IStatus } from '../../interfaces';

/**
 * Statuses for a single model, via `/states/getlistbymodelid` — the endpoint the old
 * project used. Prefer this over `useStatuses({ model_id })`, which filters the paged
 * list endpoint instead.
 */
export const useStatusesByModelId = (modelId: string | number, options?: UseQueryOptions<IStatus[], Error, IStatus[], [string, { modelId: string | number }]>) => {
  return useQuery<IStatus[], Error, IStatus[], [string, { modelId: string | number }]>(
    ['status', { modelId }],
    async ({ queryKey }) => {
      const [, { modelId: id }] = queryKey;
      const result = await StatusesService.getByModelId(id);
      if (result.status === 200) return result.data;
      throw new Error(result.data as string);
    },
    { staleTime: 1000 * 60 * 15, ...options },
  );
};
